<template>
  <div>
    <md-button
      class="md-just-icon md-warning md-simple table-action"
      @click="triggerDetail"
    >
      <md-icon>visibility</md-icon>
    </md-button>
  </div>
</template>

<script>
export default {
  props: ["item"],
  inject: ["viewCommunicationDetail"],
  methods: {
    triggerDetail() {
      this.viewCommunicationDetail(this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
